import { render, staticRenderFns } from "./Ignition.vue?vue&type=template&id=e42d0b3c&scoped=true&"
import script from "./Ignition.vue?vue&type=script&lang=js&"
export * from "./Ignition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42d0b3c",
  null
  
)

export default component.exports